import React, { useContext, useEffect, useState } from 'react';
import HeaderMainFooter from '../templates/HeaderMainFooter';
import { Badge, Box, Button, Chip, Stack, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchInput from '../components/SearchInput';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import ResultsTable from '../components/ResultsTable';
import PeriodSelector from '../components/PeriodSelector';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import AdvancedFilter from '../components/AdvancedFilter';
import SearchTypeSelector from '../components/SearchTypeSelector';
import Facets from '../components/Facets';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
export const filterMap: any = {

    group_by_description: { label: "Agregação por Descrição", showValue: false },
    group_by_cluster: { label: "Agregação por grupo", showValue: false },
    group_by_first_token: { label: "Agregação por termo relevante", showValue: false },
    group_by_unit_metric: { label: "Agregação por Unidade de Medida", showValue: false },
    group_by_year: { label: "Agregação por ano", showValue: false },
    group_by_overprice: { label: "Efetuar cálculo de sobrepreço", showValue: false },
    min_amount: { label: "Quantidade comprada mínima", showValue: true },
    max_amount: { label: "Quantidade comprada máxima", showValue: true },
    min_homolog_price: { label: "Preço unitário mínimo", showValue: true },
    max_homolog_price: { label: "Preço unitário maximo", showValue: true },
    body: { label: "Nome do Órgão", showValue: true },
    body_type: { label: "Tipo do Órgão", showValue: true },
    bidder_type: { label: "Tipo de fornecedor", showValue: true },
    bidder_name: { label: "Fornecedor", showValue: true },
    bidder_document: { label: "CNPJ", showValue: true },
    procurement_type: { label: "Licitação", showValue: true },
    modality: { label: "Modalidade", showValue: true },
    object_nature: { label: "Natureza do Objeto", showValue: true },
    city: { label: "Municípios", showValue: true },
    imediate_region: { label: "Região Imediata", showValue: true },
    inter_region: { label: "Região Intermediária", showValue: true },
    year: { label: "Ano", showValue: true },
    month: { label: "Mês", showValue: true },
    after: { label: "Data Inicial", showValue: true },
    before: { label: "Data Final", showValue: true }


}

function Result() {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { userPermissions, setUserPermissions } = useContext(GlobalStateContext);
    const { filters, setFilters, countFilters, cleanFilters } = useContext(GlobalStateContext);
    const { typedFilters, setTypedFilters, cleanFacetsFilters } = useContext(GlobalStateContext);
    const { typedDescription, setTypedDescription } = useContext(GlobalStateContext);
    const { description, setDescription } = useContext(GlobalStateContext);
    const { typedSearchType, setTypedSearchType } = useContext(GlobalStateContext);
    const { searchType, setSearchType } = useContext(GlobalStateContext);
    const navigate = useNavigate();


    const onSearch = (ev: React.FormEvent<HTMLFormElement>) => {
        cleanFacetsFilters()
        setDescription(typedDescription);
        setFilters(typedFilters);
        setSearchType(typedSearchType);
        ev.preventDefault();
        navigate(`/result`)
    }

    const showTable = () => {
        return <ResultsTable />
    }

    const convertNumberToMonth = (numbers: number[]) => {
        const monthNames = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];
        let str = ""
        for (let i = 0; i < numbers.length; i++) {

            if (numbers[i] >= 1 && numbers[i] <= 12 && numbers[i] != +',') {
                str = str + monthNames[numbers[i] - 1] + ",";
            } else {
                str = str + monthNames[numbers[i] - 1] + ",";
            }

        }
        str = str.replace('undefined,', '');
        return str
    };

    useEffect(() => {
        if (userPermissions.usuario == '') {
            navigate('/');
        }
    }, []);

    const renderFilters = () => {

        const result: string[] = [];
        const filterArray = Object.entries(filters).filter(item => item[1])
        for (const f of filterArray) {
            const filterMapped = filterMap[f[0]]

            if (filterMapped) {
                var filterResult: string = ""
                f[1] = f[1] + "";
                if (filterMapped.showValue === true && f[1].length > 0) {
                    if (filterMapped.label == "Mês") {
                        filterResult = filterMapped.label + ": " + convertNumberToMonth(f[1]);
                        result.push(filterResult)
                    } else {
                        filterResult = filterMapped.label + ": " + f[1];
                        result.push(filterResult)
                    }

                }
            }
        }

        if (filters.skip_duplicates) {
            result.push("Remover Duplicidades")
        }

        return (


            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                <Box sx={{ maxWidth: '90%' }}>
                    {
                        result.map(item => (
                            <Tooltip title={item}>
                                <Chip style={{ maxWidth: 250, marginLeft: 10 }} label={item} color="secondary" variant="outlined" size="small" />
                            </Tooltip>
                        ))
                    }
                </Box>
                {result.length > 0 ?

                    <Button sx={{ mr: 4 }} variant='text' color="warning" size='small' startIcon={<HighlightOffIcon />} onClick={cleanFilters}>
                        Resetar
                    </Button> :

                    <></>}
            </Stack>


        );
    }

    return (
        <><Box sx={{ height: '100%', }}>
            <HeaderMainFooter />
            <AdvancedFilter open={showModal} onClose={() => setShowModal(false)} />

            <div className="p-2 border-b mt-1">
                <form onSubmit={onSearch}>
                    <div className="flex items-center gap-5">
                        <div>
                            <SearchTypeSelector />
                        </div>
                        <div className="flex-1">
                            <SearchInput />
                        </div>
                        <div className='flex gap-2 items-center w-[650px]'>
                            <PeriodSelector />
                        </div>
                        <div>
                            <Badge badgeContent={countFilters()} color="primary">
                                <Button onClick={() => setShowModal(true)} size='medium'><FilterAltIcon /> Filtro</Button>
                            </Badge>
                        </div>
                        <div>
                            <Button type="submit" variant='contained' disabled={!userPermissions.print_list_items}>Buscar</Button>
                        </div>
                    </div>
                </form>
            </div>
            <div className=''>
                {renderFilters()}
            </div>
            <div className="px-2" style={{ backgroundColor: 'rgb(246 252 252)' }} >
                <div className='flex flex-row pt-1'>
                    <div className="h-result w-1/5 flew-col overflow-auto border-solid border bg-slate-50" style={{ backgroundColor: 'rgb(255 255 255)' }}>
                        <Facets />
                    </div>
                    <div className="w-4/5 ">
                        {showTable()}
                    </div>
                </div>

            </div>
        </Box >

        </>





    );
}

export default Result;


